import { BaseDialog, useDialogStore } from '@/components/dialogs';
import { Button, Typography } from '@mui/material';
import { useRouter } from '@tanstack/react-router';

export const TournamentDialog = () => {
  const router = useRouter();
  const closeDialog = useDialogStore((state) => state.closeDialog);

  const handleClose = () => {
    closeDialog('tournamentDialog');
  };

  const handleGoToTournament = () => {
    closeDialog('tournamentDialog');
    router.navigate({ to: '/leaderboard' });
  };

  const dialogActions = (
    <>
      <Button onClick={handleClose} variant="outlined" size="large" fullWidth>
        Maybe Later
      </Button>
      <Button onClick={handleGoToTournament} variant="contained" size="large" fullWidth>
        Add contact details
      </Button>
    </>
  );

  return (
    <BaseDialog
      dialogKey={'tournamentDialog'}
      title="The First Perpl Invitational Is Now Live!"
      actions={dialogActions}
      maxWidth="md"
      dialogProps={{
        slotProps: {
          paper: {
            sx: { maxWidth: 500 },
          },
        },
      }}
    >
      Trade on Perpl between 19 Nov and 23 Nov and compete against other top traders.
      <br />
      View the full prize pool and rules here:{' '}
      <a href="https://x.com/perpltrade/status/1991159234063483249?s=20" target="_blank" rel="noopener">
        @perpltrade
      </a>
      <br />
      <br />
      Bonus (Optional):
      <br /> Submit Discord handle and join our server to claim the 1st Perpl Invitational role.
    </BaseDialog>
  );
};
